import { heroImages } from "@/mocks/gossip";

const tickerItems = [
  "“停播半年”旧闻拼接反转，本人晒时间线自证",
  "颁奖礼后台“冷脸”真相曝光：困到打哈欠",
  "带货翻车事件品牌方已介入调查",
  "神秘剪影联动预告疑指头部创作者",
  "凌晨异常动态秒删，账号疑似被盗",
  "抄袭风波升级，律师函已正式发出",
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImages.banner}
          alt="扒哥吃瓜前线热点追踪背景图"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-background-950/80"></div>
      </div>

      <div className="relative mx-auto max-w-7xl px-4 pt-28 pb-16 md:px-6 md:pt-36 md:pb-24">
        <div className="flex w-full max-w-3xl flex-col">
          <div className="mb-4 flex items-center gap-2">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/90 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-flashlight-line"></i>
              全网吃瓜 实时聚焦
            </span>
            <span className="rounded-full border border-background-100/40 px-3 py-1 text-xs font-medium text-background-100">
              辟谣 · 反转 · 当事人回应 · 新瓜
            </span>
          </div>

          <h1 className="font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl md:leading-tight">
            看透每一次
            <span className="text-accent-400">瓜</span>
            ，不放过任何一个
            <span className="text-primary-400">反转</span>
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
            扒哥吃瓜前线专注热点事件的辟谣、反转与后续进展追踪。信息分层呈现，事实与观点分离，
            用可核验的信源帮你理清每条瓜的来龙去脉，拒绝被带节奏。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-sm font-bold whitespace-nowrap text-foreground-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-fire-fill"></i>
              看最新热瓜
            </a>
            <a
              href="#reverse"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-background-100/40 bg-background-100/10 px-6 py-3 text-sm font-semibold whitespace-nowrap text-background-50 backdrop-blur transition-colors hover:bg-background-100/20"
            >
              <i className="ri-history-line"></i>
              复盘反转全过程
            </a>
          </div>

          <div className="mt-10 grid max-w-xl grid-cols-3 gap-3">
            {[
              { n: "128+", t: "事件全程追踪" },
              { n: "46", t: "本月辟谣完成" },
              { n: "92%", t: "信源可溯源率" },
            ].map((s) => (
              <div key={s.t} className="rounded-lg bg-background-50/10 p-3 backdrop-blur">
                <div className="font-heading text-xl font-black text-accent-400 md:text-2xl">{s.n}</div>
                <div className="mt-1 text-xs text-background-100/80">{s.t}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative border-t border-background-100/20 bg-foreground-950/80">
        <div className="flex items-center">
          <div className="z-10 flex items-center gap-2 bg-primary-500 px-4 py-2.5 text-sm font-bold whitespace-nowrap text-background-50">
            <i className="ri-broadcast-line animate-pulse"></i>
            最新快讯
          </div>
          <div className="relative flex-1 overflow-hidden">
            <div className="ticker-track flex w-max items-center gap-10 px-4 py-2.5">
              {[...tickerItems, ...tickerItems].map((t, i) => (
                <span key={i} className="flex items-center gap-2 whitespace-nowrap text-sm text-background-100/90">
                  <i className="ri-arrow-right-up-line text-accent-400"></i>
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}